import React, { useEffect, useState } from "react";
import { DatatablesFooterServerSide, Loading, Modal } from "App/Component/ui";
import {
  getByFilterPembelian,
  RESET_STATE_FORM_FILTER,
} from "App/Component/layout/FixedAsset/Transaksi/DaftarPembelian/helpers";

import { Paper } from "@material-ui/core";
import { TableDaftarPembelian } from "../DaftarPembelian/DaftarPembelian";
import { useDatatablesServerSide } from "App/hooks";
import { defaultToastError } from "App/utils/helpers";
import { STYLE_DEFAULT_MASTER } from "App/constants";
import FormFilterDaftarPO from "../DaftarPembelian/FormFilterDaftarPembelian";


function ModalListPembelian({
  setShowModal,
  handleClickSelect,
  alwaysLunas = false,
}) {
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER);
  const [totalData, setTotalData] = useState(0);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const classes = STYLE_DEFAULT_MASTER();
  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit
  ) => {
    setLoading(true);

    const res = await getByFilterPembelian(
      formFilter,
      pages,
      limit,
      "",// 2,
      alwaysLunas,
      1,
    );
    if (res.state) {
      setRows(res.data);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setRows([]);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  useEffect(() => {
    (async () => {
      await setNewData();
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
    resetPagination,
  } = useDatatablesServerSide({ setNewData: setNewData });

  return (
    <>
      <Modal title='Pilih Pembelian' show={setShowModal} width='90%'>
        <Paper
          style={{
            padding: "1rem",
          }}>
          <FormFilterDaftarPO
            formFilter={formFilter}
            setFormFilter={setFormFilter}
            setNewData={setNewData}
            resetPagination={resetPagination}
          />
          <Loading show={loading} />
          <TableDaftarPembelian
            rows={rows}
            classes={classes}
            onlySelect={true}
            handleClickSelect={handleClickSelect}
          />
          <DatatablesFooterServerSide
            totalData={totalData}
            pagination={pagination}
            handleChangeLimit={handleChangeLimit}
            onPrevious={onPrevious}
            onNext={onNext}
            currentPage={pagination.page}
            handleClickPageNumber={handleClickPageNumber}
          />
        </Paper>
      </Modal>
    </>
  );
}

export default ModalListPembelian;
